import React from 'react';
import '../template-file-css/document-file-template.css';


export const EYPC_BlankDmasCsSra = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EYPC_BlankDmasCsSra' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>THE DEPARTMENT OF MEDICAL ASSISTANCE SERVICES <br /><br />
                    Community Stabilization (S9482) <br />
                    CONTINUED STAY Service Authorization Request Form
                </h3></center></p>

                <p className='w-750'><h4>MEMBER INFORMATION</h4></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member First Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Last Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberFirstName' name='txtMemberFirstName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberLastName' name='txtMemberLastName' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medicaid #:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Member Date of Birth:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Gender:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtMemberDateOfBirth' name='txtMemberDateOfBirth' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male&nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female</td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Plan ID #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Street Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberPlanId' name='txtMemberPlanId' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberStreetAddress' name='txtMemberStreetAddress' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>State:</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCity' name='txtCity' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtState' name='txtState' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Zip:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Phone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtZip' name='txtZip' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberPhone' name='txtMemberPhone' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Legal Guardian Name (s):</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Legal Guardian Phone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtParentLegalGuardian' name='txtParentLegalGuardian' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtParentLegalPhone' name='txtParentLegalPhone' className='add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><h4>PROVIDER INFORMATION</h4></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Organization Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Group NPI #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOrganizationName' name='txtOrganizationName' placeholder='Empowering Youth for Positive Change' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtGroupNpi' name='txtGroupNpi' defaultValue={1538446679} className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Tax ID #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Phone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderTax' name='txtProviderTax' defaultValue={473114954} className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtProviderPhone' name='txtProviderPhone' defaultValue={8047891314} className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider E-Mail:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderEmail' name='txtProviderEmail' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtProviderAddress' name='txtProviderAddress' placeholder='101 Cowardin Avenue' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity_1' name='txtCity_1' placeholder='Richmond' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtState_1' name='txtState_1' placeholder='Virginia' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtZip_1' name='txtZip_1' defaultValue={23224} className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Fax #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderFax' name='txtProviderFax' defaultValue={8044823767} className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhone' name='txtPhone' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Clinical Contact Name & Credentials*:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtClinicalContactName' name='txtClinicalContactName' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>* The individual to whom the MCO can reach out to in
                    order to gather additional necessary clinical information.</b> <br />
                    <center><h4><b>Request for Approval of Services</b></h4></center></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Retro Review Request?</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Data Platform Reference #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbRetroReviewRequest_Yes' name='rbRetroReviewRequest' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbRetroReviewRequest_No' name='rbRetroReviewRequest' className='add-only' value='No' /> No </td>
                        <td className='w-375'>
                            <input type='text' id='txtDataPlatformReference' name='txtDataPlatformReference' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If the member is currently participating in this service, start date of service:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='date' id='txtIfTheMemberisCurrentlyParticipating' name='txtIfTheMemberisCurrentlyParticipating' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>Proposed/Requested Service Information:</b><br />
                    From &nbsp;
                    <input type='date' id='txtProposedRequestedServiceInformation_1' name='txtProposedRequestedServiceInformation_1' className='add-only w-150 custom-add-only' /> (date), To &nbsp;
                    <input type='date' id='txtProposedRequestedServiceInformation_2' name='txtProposedRequestedServiceInformation_2' className='add-only w-150 custom-add-only' /> (date), for a total of &nbsp;
                    <input type='text' id='txtProposedRequestedServiceInformation_3' name='txtProposedRequestedServiceInformation_3' className='add-only w-100 custom-add-only' /> units of service. Plan to provide &nbsp;
                    <input type='text' id='txtProposedRequestedServiceInformation_4' name='txtProposedRequestedServiceInformation_4' className='add-only w-100 custom-add-only' /> hours of service per week
                    <br />

                    <span className='eleHeader'>Primary ICD-10 Diagnosis</span>
                    <input type='text' id='txtPrimaryDiagnosis' name='txtPrimaryDiagnosis' className='add-only' /> <br />

                    <span className='eleHeader'>Secondary Diagnosis(es)</span>
                    <input type='text' id='txtSecondaryDiagnosis' name='txtSecondaryDiagnosis' className='add-only' /> <br /><br />
                    <center><h4><b>Medication Update</b></h4></center></p>

                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>Name of Medication <br />&nbsp;</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>Dose <br />&nbsp;</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>Frequency <br />&nbsp;</span></td>
                        <td className='w-350'>
                            <span className='eleHeader'>For any changes, note if:
                                New, Ended or Changed in dose/frequency from
                                last authorization</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtNameOfMedication_1' name='txtNameOfMedication_1' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtDose_1' name='txtDose_1' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtForAnyChangesNoteIfNew_1' name='txtForAnyChangesNoteIfNew_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtNameOfMedication_2' name='txtNameOfMedication_2' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtDose_2' name='txtDose_2' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtForAnyChangesNoteIfNew_2' name='txtForAnyChangesNoteIfNew_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtNameOfMedication_3' name='txtNameOfMedication_3' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtDose_3' name='txtDose_3' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtForAnyChangesNoteIfNew_3' name='txtForAnyChangesNoteIfNew_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtNameOfMedication_4' name='txtNameOfMedication_4' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtDose_4' name='txtDose_4' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtForAnyChangesNoteIfNew_4' name='txtForAnyChangesNoteIfNew_4' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><h4><b>SECTION I: CARE COORDINATION</b></h4></center>
                    <b>Please list all medical/behavioral services or community interventions/supports the individual has participated in since
                        the last authorization, as well as any changes: </b></p>

                <table>
                    <tr>
                        <td className='w-180'>
                            <span className='eleHeader'>Name of Service/Support<br />&nbsp;</span></td>
                        <td className='w-180'>
                            <span className='eleHeader'>Provider Contact Info<br />&nbsp;<br />&nbsp;</span></td>
                        <td className='w-90'>
                            <span className='eleHeader'>Frequency<br />&nbsp;<br />&nbsp;</span></td>
                        <td className='w-300'>
                            <span className='eleHeader'>For any changes, note if:
                                New, Ended or Changed in
                                frequency/intensity from last authorization
                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-180'>
                            <input type='text' id='txtNameOfServiceSupport_1' name='txtNameOfServiceSupport_1' className='add-only' /></td>
                        <td className='w-180'>
                            <input type='text' id='txtProviderContactInfo_1' name='txtProviderContactInfo_1' className='add-only' /></td>
                        <td className='w-90'>
                            <input type='text' id='txtFrequency_5' name='txtFrequency_5' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtForAnyChangesNoteNewEndedChanged_1' name='txtForAnyChangesNoteNewEndedChanged_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-180'>
                            <input type='text' id='txtNameOfServiceSupport_2' name='txtNameOfServiceSupport_2' className='add-only' /></td>
                        <td className='w-180'>
                            <input type='text' id='txtProviderContactInfo_2' name='txtProviderContactInfo_2' className='add-only' /></td>
                        <td className='w-90'>
                            <input type='text' id='txtFrequency_6' name='txtFrequency_6' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtForAnyChangesNoteNewEndedChanged_2' name='txtForAnyChangesNoteNewEndedChanged_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-180'>
                            <input type='text' id='txtNameOfServiceSupport_3' name='txtNameOfServiceSupport_3' className='add-only' /></td>
                        <td className='w-180'>
                            <input type='text' id='txtProviderContactInfo_3' name='txtProviderContactInfo_3' className='add-only' /></td>
                        <td className='w-90'>
                            <input type='text' id='txtFrequency_7' name='txtFrequency_7' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtForAnyChangesNoteNewEndedChanged_3' name='txtForAnyChangesNoteNewEndedChanged_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-180'>
                            <input type='text' id='txtNameOfServiceSupport_4' name='txtNameOfServiceSupport_4' className='add-only' /></td>
                        <td className='w-180'>
                            <input type='text' id='txtProviderContactInfo_4' name='txtProviderContactInfo_4' className='add-only' /></td>
                        <td className='w-90'>
                            <input type='text' id='txtFrequency_8' name='txtFrequency_8' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtForAnyChangesNoteNewEndedChanged_4' name='txtForAnyChangesNoteNewEndedChanged_4' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><h4><b>Section II: TREATMENT PROGRESS</b></h4></center>
                    <b>Along with this document, please include the following with your submission: </b><br />
                    1. An assessment meeting one of the following: <br />

                    <ol type='a'>
                        <li>Comprehensive Needs Assessment (CNA), <b>or</b></li>
                        <li><u>Prescreening</u>completed within 72-Hours of admission <b>or</b></li>
                        <li>A <u>DBHDS approved assessment</u> for crisis services can be used to meet this requirement if conducted by a LMHP,
                            LMHP-R, LMHP-RP, or LMHP-S; <b>and</b></li>
                    </ol>
                </p>

                <p className='w-750'>
                    2. A current <u>addendum</u>to the above assessment, (can be in a progress note) that briefly describes any new information
                    impacting care, progress and interventions to date, and a description of the rationale for continued service delivery,
                    and evidence the individual meets medical necessity criteria <b>and</b><br />

                    3. Current Safety Plan
                </p>


                <p className='w-750'><center><h4><b>Section III: RECOVERY and DISCHARGE PLANNING</b></h4></center>
                    <span className='eleHeader'>1. A clinically appropriate and specific behavioral health service provider referral(s) has been identified and a plan
                        for the timeline of transition from Community Stabilization to that provider has been established and documented.
                        Provide updated details about the transition plan: specific dates and times for the assessment or start of service, any
                        details about transition sessions, barriers to the transition and attempted solutions to those barriers</span>
                    <textarea id='txtClinicallyAppropriateSpecific' name='txtClinicallyAppropriateSpecific' className='add-only'></textarea> <br />

                    <span className='eleHeader'>2. {`If the timeline for this transition (#iii,b) exceeds 2 weeks, the Community Stabilization provider has documented
                        communications with additional, specific service providers to support additional service options or potentially faster
                        access to the recommended service type. Please provide updated additional referral information, service type/
                        procedure code, provider and contact information (if applicable) since the last service authorization.`}
                    </span>
                    <textarea id='txtIfTheTimelineForThisTransitionExceeds' name='txtIfTheTimelineForThisTransitionExceeds' className='add-only'></textarea> <br />

                    <span className='eleHeader'>3. What types of outreach, additional formal services or natural supports, or resources will be necessary to
                        transition the individual to a service (s) that will meet the individual's needs?
                    </span>
                    <textarea id='txtWhatTypeOfOutReachAdditionalFormal' name='txtWhatTypeOfOutReachAdditionalFormal' className='add-only'></textarea> <br />

                    <span className='eleHeader'>4. Has the provider contacted the health plan and engaged in care coordination to assist the individual, if so, who
                        was contacted, when and what was the outcome?</span>
                    <textarea id='txtHasTheProviderContactedTheHealth' name='txtHasTheProviderContactedTheHealth' className='add-only'></textarea> <br />

                    What is the best estimate of the discharge date for this individual?&nbsp;
                    <input type='date' id='txtWhatIsTheBestEstimateOfTheDischargeDate_4' name='txtWhatIsTheBestEstimateOfTheDischargeDate_4' className='add-only w-200 custom-add-only' /> <br />

                    By my signature (below), I am attesting that 1) an LMHP, LMHP-R, LMHP-S or LMHP-RP has reviewed the individual's
                    psychiatric history and completed the appropriate assessment or addendum; and 2) that this assessment indicates that
                    the individual meets the medical necessity criteria for the identified service. The assessment or applicable addendum
                    for this service was completed on the following date(s):
                    <input type='date' id='txtByMySignatureBelowIAmAttesting_4' name='txtByMySignatureBelowIAmAttesting_4' className='add-only w-200 custom-add-only' />
                </p>

                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>

                    </tr>
                    <tr>
                        <td className='small w-750'>Signature (actual or electronic) of LMHP (Or R/S/RP):</td>

                    </tr>
                    <tr>
                        <td className='w-300'>
                            <span className='eleHeader'>Printed Name of LMHP (Or R/S/RP)</span></td>
                        <td className='w-300'>
                            <span className='eleHeader'>Credentials:</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='text' id='txtPrintedName' name='txtPrintedName' className='add-only' /></td>
                        <td className='w-300'>
                            <input type='text' id='txtCredentials' name='txtCredentials' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><h4><b>Notes Section</b></h4></center>
                    <textarea id='txtNotesSection' name='txtNotesSection' className='add-only'></textarea></p>
































            </div >
        </form >

    )
}











